import {MuBinder} from "mu-widget/lib/MuBinder";
import {formatDate, getBrightness, toDate} from "./Utils";

export function setupFilters() {
	MuBinder.filters.percent = (value : number) => value.toString() + "%";
	MuBinder.filters.percentD = (value : number) => (value * 100).toString() + "%";
	MuBinder.filters.number2d = (value : number) => (Math.round(value * 100) / 100).toFixed(2).toLocaleString();
	MuBinder.filters.date = function(value : Date|string, ev, format : string = "date") {
		if (!value) return '';
		if (typeof value === "string") value = new Date(value);
		//todo: format

		const optss = {
			date: {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			},
			datetime: {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
			}
		}
		return value.toLocaleDateString('cz-CZ', optss[format]);
	};
	MuBinder.filters.dateTime = (value, ev, format: string = "d.m.Y H:i") => {
		if (!value) return '';
		value = toDate(value);
		return formatDate((format === 'auto-date-time')
			? (value.getHours() || value.getMinutes() || value.getSeconds()
				? "d.m.Y H:i"
				: "d.m.Y"
			)
			: format, value);
	}
	MuBinder.filters.snumber = (value : string) => {
		let f = true;
		let res = "";
		value = "   " + value.toString().padStart(3, '0');
		res = ',' + value.substr(-2);

		for(let p = value.length - 5; p >= 0; p -= 3) {
			res = ' ' + value.substr(p, 3) + res;
		}
		return res;
	}
	MuBinder.filters.price = (value: number) => value;
	MuBinder.filters.priceI100 = (value: string) => parseInt(value) / 100;
	MuBinder.filters.priceI100r = (value: string) => Math.round(parseFloat(value) * 100);
	MuBinder.filters.priceV = (value: number) => MuBinder.filters.snumber(Math.round(value * 100));
	MuBinder.filters.dateToInput = (date: Date|string|object, ev, onlyDate: boolean) => {
		if (!date) return "";
		if (typeof date === "string") date = new Date(date);
		else if (date instanceof Date) { }
		else if (typeof date === "object") {
			return onlyDate
				? date.date?.substr(0, 10)
				: date.date?.substr(0, 18)?.replace(' ', 'T');
		}

		const timezoneOffset = date.getTimezoneOffset() * 60000;

		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');

		const localDateFormat = `${year}-${month}-${day}`;

		const localDateTimeFormat = new Date(date - timezoneOffset).toISOString();

		return localDateFormat + (!onlyDate ? `T${localDateTimeFormat.substr(11, 8)}` : '');
	}
	MuBinder.filters.dateToInputD = (date: Date|string, ev) => MuBinder.filters.dateToInput(date, ev, true);
	MuBinder.filters.getField = (src: any, ev, field) => src ? src[field] : undefined;
	MuBinder.filters.any = (src: []) => src.length > 0;
	MuBinder.filters.join = (arr: [], ev, separator: string = ", ") => arr.join(separator);
	MuBinder.filters.bwContrasted = (color) => (getBrightness(color) ?? 255) > 160 ? "black" : "white";
}
